import {
  CheckCircleIcon,
  CrossCircleIcon,
  PendingCircleIcon,
} from '@root/shared/ui-kit'

import type { Transaction } from '../model'
import type { TransKey } from '@root/shared/localization'
import type { IconProps } from '@root/shared/ui-kit'

export const TRX_TYPE_COLOR_MAP: Record<Transaction.Type, string> = {
  transfer: 'var(--primary-9)',
  // TODO: review tx color mapping
  buy: 'var(--up-9)', //#A1FF29;
  sell: 'var(--down-9)',
  swap: '#00E0FF',
}

export const TRX_TYPE_LABEL_MAP: Record<Transaction.Type, TransKey> = {
  transfer: 'transaction.type_transfer',
  buy: 'transaction.type_buy',
  sell: 'transaction.type_sell',
  swap: 'transaction.type_swap',
}

export const TRX_STATUS_ICON_MAP: Record<
  Transaction.Status,
  React.FC<IconProps>
> = {
  failed: CrossCircleIcon,
  success: CheckCircleIcon,
  pending: PendingCircleIcon,
}

export const TRX_STATUS_COLOR_MAP: Record<Transaction.Status, string> = {
  failed: 'var(--errorAccent-9)',
  success: 'var(--successAccent-9)',
  pending: 'var(--subscriptionButton-9)',
}

export const TRX_STATUS_LABEL_MAP: Record<Transaction.Status, TransKey> = {
  failed: 'transaction.status_failed',
  success: 'transaction.status_success',
  pending: 'transaction.status_pending',
}
